import { render, staticRenderFns } from "./view404.vue?vue&type=template&id=530573f0&"
import script from "./view404.vue?vue&type=script&lang=js&"
export * from "./view404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports